export default __webpack_public_path__ + "static/media/location.8210970a.png";